<ion-app>
  <ion-menu side="start" contentId="mainMenu">
    <ion-header>
      <ion-toolbar>
        <ion-title>
          OD Dashboard
        </ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list>
        <ion-menu-toggle>
          <ion-item lines="none" routerLink="/dashboard">
            <ion-icon name="speedometer-outline" slot="start"></ion-icon>
            <ion-label>Dashboard</ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle>
          <ion-item lines="none" routerLink="/info">
            <ion-icon name="information-circle-outline" slot="start"></ion-icon>
            <ion-label>Informatie</ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle>
          <ion-item lines="none" (click)="onLogout()" button>
            <ion-icon name="exit-outline" slot="start"></ion-icon>
            <ion-label>Uitloggen</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="mainMenu"></ion-router-outlet>
</ion-app>